import React, { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Paw } from "../components/Doodles";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get("email") || "");
  const [state, setState] = useState("idle"); // idle | submitting | done | error
  const [autoRan, setAutoRan] = useState(false);

  const submit = async (e) => {
    if (e) e.preventDefault();
    if (!email) return;
    setState("submitting");
    try {
      await api.post("/unsubscribe", { email });
      setState("done");
    } catch {
      setState("error");
    }
  };

  // If email arrives via query string, auto-unsubscribe once
  useEffect(() => {
    if (params.get("email") && !autoRan) {
      setAutoRan(true);
      submit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="max-w-xl mx-auto px-6 py-20 text-center" data-testid="unsubscribe-page">
      <Paw className="w-10 mx-auto opacity-30 mb-6" />
      <p className="font-typewriter text-sm tracking-[0.3em] text-[#C84B31] mb-2">/ UNSUBSCRIBE</p>

      {state === "done" ? (
        <>
          <h1 className="font-brush text-6xl">YOU'RE OFF THE LIST.</h1>
          <p className="font-cormorant text-2xl italic mt-4">
            No more Wednesday tips. We'll miss you. Mr. Mack will too.
          </p>
          <Link to="/" data-testid="unsub-home-btn" className="btn-brutal mt-8 inline-flex">BACK HOME</Link>
        </>
      ) : (
        <>
          <h1 className="font-brush text-6xl">SAD TO SEE YOU GO.</h1>
          <p className="font-cormorant text-xl italic mt-4">
            Pop your email in to unsubscribe from the weekly dog tip.
          </p>
          <form onSubmit={submit} className="paper-card bg-[#FDFBF7] p-6 mt-8 flex flex-col sm:flex-row gap-3">
            <input
              data-testid="unsub-email"
              type="email"
              className="input-typewriter flex-1"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button data-testid="unsub-submit" type="submit" disabled={state === "submitting"} className="btn-brutal">
              {state === "submitting" ? "..." : "UNSUBSCRIBE"}
            </button>
          </form>
          {state === "error" && (
            <p className="font-typewriter text-sm mt-4 text-[#C84B31]">Something went wrong. Try again or email helloaskkimberley@gmail.com.</p>
          )}
        </>
      )}
    </div>
  );
}
